import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import CommonInput from "../../../../Layouts/CommonInput";
import CommonModal from "../../../../Modals/CommonModal";
import Style from ".././AddNewFolderModal.module.scss";
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
  useFormik,
  useFormikContext,
} from "formik";
import * as Yup from "yup";
import Icon from "../../../../Layouts/Icons";
import { useAddNewFolder } from "../../../../../Logic/useAddNewFolder";
import InfiniteDotLoader from "../../../../../utils/InfiniteDotLoader";
import AddStaff from "../../../PreferenceList/Components/AddStaff";
import {
  getAllStaffsAPI,
  saveStudioAsStaff,
} from "../../../../../store/slices/Staffs/staffsSlice";
import { useLocation } from "react-router-dom";
export const FormFields = ({
  handleCancel,
  handleSubmitCreateNewFolder,
  handleStaffModal,
  isEdit,
  currentTab,
  noStaffs,
}) => {
  const customSelectRef = useRef();
  const {
    initialInput,
    customFieldName,
    setCustomFieldName,
    getSelectedEventCategory,
    getSelectedStaffsArray,
    createNewFolder,
    allFolders,
    handleSkipStaff,
    staffSkipStatus,
    skipStatus,
    handleCreateNewFolder,
    handleSaveEventCreateModalData,
    handleClearEventCreateData,
    eventModalData,
    addStaffStatus,
  } = useAddNewFolder();
  const dispatch = useDispatch();
  const savedEventName = createNewFolder.events.filter(
    (item) => item.value == eventModalData?.eventName
  );
  const savedEventCategory = createNewFolder.eventCategories.filter(
    (item) => item.value == eventModalData?.eventCategory
  );

  // for focusing custom input
  const customNameInput = useRef();
  const location = useLocation();

  useEffect(() => {
    if (customFieldName) {
      customNameInput.current.focus();
    }
  }, [customFieldName]);

  // validation schema  for event creation
  const SignupSchema = Yup.object().shape({
    eventName: Yup.string().required("Event name is required"),
    customName: Yup.string().when("eventName", (eventName) => {
      if (eventName === "custom")
        return Yup.string().required("Event name is required");
    }),
    location: Yup.string().required("Location is required"),
    date: Yup.string().required("Date is required"),
    eventCategory: Yup.string().required("Event category is required"),
    staff: Yup.array().of(Yup.string()).nullable(),
  });
  return (
    <>
      <Formik
        initialValues={initialInput}
        onSubmit={(values, { resetForm }) => {
          if (eventModalData?.eventName) {
            let data = {
              customName: eventModalData?.customName,
              date: eventModalData?.date,
              eventCategory: eventModalData?.eventCategory,
              eventName: eventModalData?.eventName,
              location: eventModalData?.location,
              staff: values?.staff,
            };
            handleSubmitCreateNewFolder(data, resetForm);
          } else {
            handleSubmitCreateNewFolder(values, resetForm);
          }

          if (skipStatus) {
            handleCreateNewFolder();
          }
          if (eventModalData?.eventName) {
            handleClearEventCreateData();
          }
          handleClearEventCreateData();
        }}
        validationSchema={
          Number.isInteger(eventModalData?.eventName) ? "" : SignupSchema
        }
        enableReinitialize={true}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleSubmit,
          setFieldValue,
          dirty,
          isValid,
        }) => {
          return (
            <>
              <Row>
                <Col sm={12} xs={12}>
                  {!customFieldName && (
                    <CommonInput
                      ref={customSelectRef}
                      label="Event Name"
                      variant="select-input"
                      name="input_event_name"
                      id="input_event_name"
                      floatingLabel={true}
                      onBlur={handleBlur}
                      options={createNewFolder.events}
                      selectedValue={
                        Number.isInteger(
                          allFolders?.editFolder?.details?.album_name_id
                        ) || Number.isInteger(eventModalData?.eventName)
                          ? {
                              value: eventModalData?.eventName
                                ? eventModalData?.eventName
                                : allFolders?.editFolder?.details
                                    ?.album_name_id,
                              label: eventModalData?.eventName
                                ? savedEventName[0].label
                                : allFolders?.editFolder?.details?.name,
                            }
                          : false
                      }
                      callback={(value) => {
                        setFieldValue(
                          "eventName",
                          eventModalData?.eventName
                            ? eventModalData?.eventName
                            : value
                        );

                        if (value === "custom") {
                          setCustomFieldName(true);
                        } else {
                          setCustomFieldName(false);
                        }
                      }}
                      hasError={errors?.eventName && touched.input_event_name}
                      errorMsg={errors?.eventName}
                    />
                  )}
                  <div className={Style.custom_event_input_wrap}>
                    <CommonInput
                      customNameInputRef={customNameInput}
                      type="text"
                      className={customFieldName === true ? "" : "d-none"}
                      label="Event Name"
                      variant="input"
                      name="customName"
                      id="customName"
                      floatingLabel={true}
                      value={
                        eventModalData?.customName
                          ? eventModalData?.customName
                          : values.customName
                      }
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("customName", e.target.value);
                      }}
                      hasError={errors?.customName && touched.customName}
                      errorMsg={errors?.customName}
                    />
                    {values?.customName?.length > 1 ? (
                      <button
                        className={`${Style.custom_event_close_btn} ${
                          customFieldName === true ? "" : "d-none"
                        }`}
                        onClick={() => {
                          setFieldValue("eventName", "");
                          setFieldValue("customName", "");
                          setCustomFieldName(false);
                        }}
                      >
                        <Icon color={""} size={14} icon={"icon-close"} />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col lg={6}>
                  <CommonInput
                    type="text"
                    label="Location"
                    variant="location-input"
                    name="location"
                    id="location"
                    floatingLabel={true}
                    className="button-sibling-prefix"
                    value={
                      eventModalData?.location
                        ? eventModalData?.location
                        : values.location
                    }
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue(
                        "location",
                        eventModalData?.location
                          ? eventModalData?.location
                          : e.target.value
                      );
                    }}
                    hasError={errors?.location && touched.location}
                    errorMsg={errors?.location}
                  />
                </Col>
                <Col lg={6}>
                  <CommonInput
                    label="Date"
                    variant="date-picker"
                    id="date"
                    name="date"
                    onBlur={handleBlur}
                    dataPickerValue={
                      allFolders?.editFolder?.status === true
                        ? allFolders?.editFolder?.details?.date
                        : eventModalData?.date !== undefined ||
                          allFolders?.editFolder?.status === false
                        ? eventModalData?.date
                        : ""
                    }
                    floatingLabel={true}
                    datePickerCallback={(dateValue) => {
                      setFieldValue(
                        "date",
                        eventModalData?.date ? eventModalData?.date : dateValue
                      );
                    }}
                    hasError={errors?.date && touched?.date_picker}
                    errorMsg={errors?.date}
                  />
                  {/* <span htmlFor="input_date" className="error-message"> {errors?.date}</span> */}
                </Col>
                <Col sm={12} xs={12}>
                  <CommonInput
                    label="Event Category"
                    variant="select-input"
                    name="input_event_category"
                    id="input_event_category"
                    onBlur={handleBlur}
                    placeholder=""
                    floatingLabel={true}
                    selectedValue={
                      eventModalData?.eventCategory
                        ? {
                            value: eventModalData?.eventCategory,
                            label: savedEventCategory[0]?.label,
                          }
                        : getSelectedEventCategory(createNewFolder)
                    }
                    options={createNewFolder.eventCategories}
                    callback={(value) => {
                      setFieldValue(
                        "eventCategory",
                        eventModalData?.eventCategory
                          ? eventModalData?.eventCategory
                          : value
                      );
                    }}
                    hasError={
                      errors?.eventCategory && touched?.input_event_category
                    }
                    errorMsg={errors?.eventCategory}
                  />
                </Col>
                <Col sm={12} xs={12}>
                  {skipStatus ? (
                    <p className={Style.form_Staff_skiped}>Staff skipped!</p>
                  ) : noStaffs ? (
                    <div className="form-error-note">
                      <p className="form-note">
                        You have no available staffs. Do you want to add staff?
                      </p>
                      <button
                        className="btn btn-border-grey"
                        onClick={() => {
                          handleSkipStaff();
                        }}
                        disabled={!isValid}
                      >
                        Skip Staff
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          handleStaffModal();
                          if (!eventModalData?.eventName) {
                            handleSaveEventCreateModalData(values);
                          }
                        }}
                        disabled={!isValid}
                      >
                        Add Staff
                      </button>
                    </div>
                  ) : (
                    <CommonInput
                      label="Add Staff"
                      variant="multi-select-input"
                      id="input_add_staff"
                      name="input_add_staff"
                      placeholder=""
                      floatingLabel={true}
                      defaultValue={getSelectedStaffsArray()}
                      options={createNewFolder?.staffList}
                      getValue={(staffs) => {
                        const staffArray = staffs?.map((staff) => staff?.value);
                        setFieldValue("staff", staffArray.join(","));
                      }}
                      hasError={errors?.staff && touched.input_add_staff}
                      errorMsg={errors?.staff}
                      onBlur={handleBlur}
                    />
                  )}
                </Col>
              </Row>
              <div className="modal-footer">
                <button
                  className="btn btn-border-grey"
                  onClick={() => {
                    handleCancel(false);
                    handleClearEventCreateData();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={
                    !isValid ||
                    (createNewFolder?.staffList?.length > 0 &&
                      values?.staff == "") ||
                    (createNewFolder?.staffList?.length === 0 &&
                      createNewFolder?.staffListIsLoading !== "loading")
                      ? !skipStatus
                      : "" || createNewFolder?.status === "loading"
                  }
                >
                  {addStaffStatus === "loading" ||
                  createNewFolder?.status === "loading" ? (
                    <InfiniteDotLoader />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </>
          );
        }}
      </Formik>
    </>
  );
};
